import {
  normaliseFinplanRows,
  normaliseFinplanSplit,
} from "./finplanStatementParser";
import { getFinplanPlanType, mapFinplanPlanType } from "./finplanPlanTypes";
import { databaseAdviserName } from "./globalSummaryRows";

const clean = (value) => String(value ?? "").trim();

export const normaliseFinplanAdviserName = (value) =>
  clean(value)
    .replace(/\s*\([^()]*@[^()]*\)\s*$/, "")
    .split(/\s+-\s+/)[0]
    .replace(/^(mr|mrs|ms|miss|dr)\.?\s+/i, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const linksBySource = (links = []) =>
  new Map(
    links.map((link) => [
      normaliseFinplanAdviserName(link.sourceName),
      link,
    ]),
  );

const resolveAdviser = (sourceName, links, advisersByName, advisersByEmail) => {
  const override = links.get(normaliseFinplanAdviserName(sourceName));
  if (override?.email) {
    return advisersByEmail.get(clean(override.email).toLowerCase()) || override;
  }
  return advisersByName.get(normaliseFinplanAdviserName(sourceName));
};

export const linkFinplanStatementRows = ({
  rows = [],
  advisers = [],
  recipientLinks = [],
  sellingAdviserLinks = [],
}) => {
  const advisersByName = new Map(
    advisers.flatMap((adviser) => [
      adviser.name,
      databaseAdviserName(adviser),
    ]
      .map((name) => [normaliseFinplanAdviserName(name), adviser])
      .filter(([name]) => name)),
  );
  const advisersByEmail = new Map(
    advisers.map((adviser) => [clean(adviser.email).toLowerCase(), adviser]),
  );
  const savedRecipientLinks = linksBySource(recipientLinks);
  const savedSellingAdviserLinks = linksBySource(sellingAdviserLinks);

  return rows.map((row) => {
    const finplanPlanType = getFinplanPlanType(row);
    const recipient = resolveAdviser(
      row.Recipient,
      savedRecipientLinks,
      advisersByName,
      advisersByEmail,
    );
    const sellingAdviser = resolveAdviser(
      row["Selling Adviser"],
      savedSellingAdviserLinks,
      advisersByName,
      advisersByEmail,
    );
    return {
      ...row,
      Recipient: recipient
        ? databaseAdviserName(recipient, row.Recipient)
        : row.Recipient,
      "Selling Adviser": sellingAdviser
        ? databaseAdviserName(sellingAdviser, row["Selling Adviser"])
        : row["Selling Adviser"],
      "Business Type": mapFinplanPlanType(finplanPlanType),
      FinplanPlanType: finplanPlanType,
      Split: normaliseFinplanSplit(row.Split),
      "Recipient Email": recipient?.email || "",
      "Selling Adviser Email": sellingAdviser?.email || "",
    };
  });
};

export const finplanCommissionRows = ({
  statement,
  advisers = [],
  statementMonth = "",
}) => normaliseFinplanRows(
  linkFinplanStatementRows({
    rows: statement?.rows || [],
    advisers,
    recipientLinks: statement?.recipientLinks || [],
    sellingAdviserLinks: statement?.sellingAdviserLinks || [],
  }),
  statementMonth,
);
